import styled from 'styled-components'

export const CheckBoxLabel = styled.label`
    top: 0;
    left: 0;
    z-index: 2;
    width: 42px;
    height: 26px;
    border-radius: 15px;
    background: #bebebe;
    cursor: pointer;
    &::after {
        content: '';
        display: block;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        margin: 3px;
        background: #ffffff;
        box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
        transition: 0.2s;
        z-index: 2;
    }
`
export const CheckBox = styled.input`
    opacity: 0;
    z-index: 2;
    border-radius: 15px;
    width: 42px;
    height: 26px;

    &:checked + ${CheckBoxLabel} {
        background: #4fbe79;
        z-index: 2;
        &::after {
            content: '';
            z-index: 2;

            display: block;
            border-radius: 50%;
            width: 18px;
            height: 18px;
            margin-left: 21px;
            transition: 0.2s;
        }
    }
    // &:not(:checked) + ${CheckBoxLabel} {
    //     background: red;
    // }
`
